export const TO_DATE = 'toDate';
export const FROM_DATE = 'fromDate';
export const UP = 'UP';
export const DOWN = 'DOWN';
export const STABLE = 'STABLE';
export const HIGH = 'HIGH';
export const LOW = 'LOW';
export const MEDIUM = "MEDIUM";
export const NEEDS_UPDATE = 'NEEDSUPDATE';
export const UPGRADE = 'UPGRADE';
export const INPROGRESS = 'INPROGRESS';
export const UPDATED = 'UPDATED';
export const ENTER = 'Enter';
export const REPORT_TYPE = "REPORT_TYPE";
export const COUNTER_PARTY_TYPE = 'COUNTER_PARTY_TYPE';
export const REGION = 'REGION';
export const RISK_LEVEL = 'RISK_LEVEL';
export const RISK_LEVEL_FILTER = ['LOW', 'MEDIUM', 'HIGH'];
export const REPORT_TYPE_FILTER = ['QUICK', 'BUSINESS', 'COMPREHENSIVE'];
export const CREATE = 'CREATE';
export const PORTFOLIO_BUY = 'PORTFOLIO_BUY';
export const PORTFOLIO_SINGLE_BUY = 'PORTFOLIO_SINGLE_BUY';
export const PAGE_SIZE = 20;
export const DEFAULT_SORT_FIELD = 'dueOrCompletedDate';
export const SORT_TYPE_DESCENDING = 'desc';
export const SORT_TYPE_ASCENDING = 'asc';
export const DEFAULT_REQUEST_BODY = {
    counterpartyFilter: [],
    zoneFilter: [],
    riskLevelFilter: [],
    productNameFilter: [],
    riskScoreTrendFilter: [],
    legalConstitutionFilter: [],
    businessSegmentFilter: [],
    caseStatusFilter: [],
    toDate: null,
    fromDate: null,
    searchString: ''
}